import { render, staticRenderFns } from "./question-data.vue?vue&type=template&id=1766d339&scoped=true&"
import script from "./question-data.vue?vue&type=script&lang=js&"
export * from "./question-data.vue?vue&type=script&lang=js&"
import style0 from "./question-data.vue?vue&type=style&index=0&id=1766d339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766d339",
  null
  
)

export default component.exports